'use client';

import { useLingui } from '@lingui/react';
import { OAuth2Button, UploadFileForm } from '@prismo-io/feature-tsid';
import { Application, useRouter } from '@prismo-io/router';
import type { LanguageCodeT } from '@prismo-io/schemas';
import { type ComponentProps, type FC, useCallback, useTransition } from 'react';
type ExtendsProps<T extends {
  onComplete?: () => void;
}> = Omit<T, 'onComplete'> & {
  stepIdx: number;
};
type Props = ExtendsProps<ComponentProps<typeof UploadFileForm>> | ExtendsProps<ComponentProps<typeof OAuth2Button>>;
export const StepToolWrapper: FC<Props> = props => {
  const {
    stepIdx,
    action,
    tool
  } = props;
  const [isTransiting, startTransition] = useTransition();
  const router = useRouter();
  const {
    i18n
  } = useLingui();
  const onComplete = useCallback(() => {
    startTransition(() => {
      router.push({
        app: Application.ONBOARDING,
        path: '/parcours/etapes/:step',
        params: {
          step: stepIdx + 1
        },
        locale: i18n.locale as LanguageCodeT
      });
    });
  }, [router]);
  switch (action.kind) {
    case 'UPLOAD_FILE':
      return <UploadFileForm tool={tool} action={action} onComplete={onComplete} />;
    case 'OAUTH2':
      return <OAuth2Button tool={tool} action={action} onComplete={onComplete} />;
    default:
      return null;
  }
};